import React, { useEffect } from 'react';
import type { ComponentType, ReactNode } from 'react';

import { withFlags } from '@confluence/flags/entry-points/withFlags.ts';
import type { FlagsStateContainer } from '@confluence/flags/entry-points/FlagsStateContainer.ts';
import { ErrorDisplay } from '@confluence/error-boundary/entry-points/ErrorDisplay.ts';
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop-utils/entry-points/ApolloErrorInterop.ts';

type ActionErrorFlagProps = {
	title: ReactNode;
	description: ReactNode;
	error: ApolloErrorInterop;
};

export const ActionErrorFlag: ComponentType<ActionErrorFlagProps> = withFlags(
	({ flags, title, description, error }: ActionErrorFlagProps & { flags: FlagsStateContainer }) => {
		useEffect(() => {
			void flags.showErrorFlag({
				id: 'action-button-error',
				title,
				description,
			});
		}, [title, description, flags]);

		return <ErrorDisplay error={error} />;
	},
);
